import React from "react";
import styled from "styled-components";
import { mobile } from "../Responsive";
import Product from "./Product";
import { products } from "../data";

const Pl = styled.div`
  padding: 50px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  ${mobile({ padding: "10px" })}
`;
const PlTexts = styled.div`
  width: 65%;
  ${mobile({ width: "100%" })}
`;
const PlTitle = styled.h1`
  font-size: 50px;
  font-weight: 600;
`;
const PlDesc = styled.p`
  margin: 20px 0px;
  ${mobile({ display: "none" })}
`;
const PlList = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const ProductList = () => {
  return (
    <Pl>
      <PlTexts>
        <PlTitle>Create & inspire.</PlTitle>
        <PlDesc>
          I want to make cool stuff with <b>CODE</b>, Have a look to my
          portfolio.
        </PlDesc>
      </PlTexts>
      <PlList>
        {products.map((item) => (
          <Product key={item.id} img={item.img} link={item.link} />
        ))}
      </PlList>
    </Pl>
  );
};

export default ProductList;
